import React, { useEffect, useRef, useState } from "react";
import CardSection from "../../components/Card/CardSection";
import {
  formatAccountNumber,
  formatRupiah,
  toastNotify,
} from "../../utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import bg from "../../assets/images/bg-onboarding.png";
import bgSuccess from "../../assets/images/bg-success.png";
import CheckImg from "../../assets/images/check.png";
import Button from "../../components/Button/Button";
import ModalLoading from "../../components/ModalLoading";
import { requestAuthGet, requestAuthPost } from "../../api/authInstance";
import _ from "lodash";
import CountdownRenderer from "../../components/CountdownRenderer";
import useClipboard from "../../hooks/useClipboard";
import PaymentInstructions from "./Instruction";

const BANK_LOGO = {
  MANDIRI:
    "https://cdn.kar-tini.id/01_Mandiri_Master_Brand_Logo_f0caaeae87.png",
  BNI: "https://cdn.kar-tini.id/bank_bni_seeklogo_ccb6648f5f.png",
  // BRI: "https://cdn.kar-tini.id/bri_logotyp_us_fccc33abbb.png",
  // BSI: "https://cdn.kar-tini.id/bank_syariah_indonesia_seeklogo_dabbeaa31c.png",
  // BCA: "https://cdn.kar-tini.id/Logo_BCA_Biru_1_2ebf6623d3.png",
  CIMB: "https://cdn.kar-tini.id/cimb_seeklogo_775285e3fa.png",
  PERMATA:
    "https://cdn.kar-tini.id/01_Mandiri_Master_Brand_Logo_f0caaeae87.png",
  DANAMON:
    "https://cdn.kar-tini.id/Bank_Danamon_Logo_PNG_480p_Vector69_Com_efd2ebc821.png",
  BTPN: "https://cdn.kar-tini.id/Bank_BTPN_koleksilogo_com_8d3124c117.png",
};

const RefundConfirmation = () => {
  const { state } = useLocation();
  const getCopyHandler = useClipboard();
  const [copiedVirtualAccount, copyVirtualAccount] =
    getCopyHandler("accountNumber");
  const [copiedAmount, copyAmount] = getCopyHandler("amount");
  const navigate = useNavigate();
  const {
    ewalletSubmission,
    id,
    description,
    nominal,
    bank,
    project,
    retailer,
  } = state || {};
  const [step, setStep] = useState(1);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  // State to hold the stable target date for the countdown
  const [countdownTargetDate, setCountdownTargetDate] = useState(null);
  const [message, setMessage] = useState({
    message: "",
    type: "",
    isShow: false,
    paymentMethod: "",
  });

  // Use a ref to ensure we only set the target date once when step transitions to 2
  const hasCountdownStarted = useRef(false);

  useEffect(() => {
    // When the step transitions to 2, set the countdown target date
    if (step === 2 && !hasCountdownStarted.current) {
      setCountdownTargetDate(Date.now() + 24 * 60 * 60 * 1000); // 24 hours from now
      hasCountdownStarted.current = true; // Mark that the countdown has been initialized
    }
    // If step changes away from 2, you might want to reset hasCountdownStarted.current to false
    // if the countdown should restart when returning to step 2.
    // For now, it will only start once per component mount.
  }, [step]); // Dependency array: run this effect when 'step' changes

  useEffect(() => {
    const refundData = JSON.parse(localStorage.getItem("refundData") || "{}");

    if (!_.isEmpty(refundData)) {
      const now = Date.now();
      const expDate = new Date(refundData.expDate).getTime();

      // Only restore refund data if it has not expired yet
      if (expDate > now) {
        setPaymentData(refundData);
        setStep(2);
      } else {
        setPaymentData(refundData);
        // make sure the status is already expired or not, if the previous data is expired then remove the previous data and allow user to generate new payment. if its completed then show success page
        CheckStatus(refundData.id, true);
      }
    }
  }, []);

  const BannerMessage = () => {
    return (
      <>
        <img src={bgSuccess} alt="" className="absolute top-0 -z-50 w-full" />
        <div className="pt-24">
          <div className="flex flex-col items-center justify-center gap-2">
            {message.type === "success" && <img src={CheckImg} alt="Success" />}
            <p className="mt-3 text-xl font-semibold">Proses Refund Berhasil</p>
            <span className="text-xs text-monochrome-300">
              {message.message}
            </span>
          </div>
        </div>
        <div className="mt-5 px-5">
          <CardSection title="Pengajuan Refund">
            <div className="">
              <div className="space-y-2">
                <div className="grid grid-cols-5 text-xs">
                  <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                    ID Proposal
                  </div>
                  <p className="col-span-3 text-right text-monochrome-600">
                    {paymentData.proposalId ?? "-"}
                  </p>
                </div>
                <div className="grid grid-cols-5 text-xs">
                  <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                    Metode Pembayaran
                  </div>
                  <p className="col-span-3 text-right text-monochrome-600">
                    {message?.paymentMethod ?? "-"}
                  </p>
                </div>
                <div className="grid grid-cols-5 text-xs">
                  <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                    Nominal Refund
                  </div>
                  <p className="col-span-3 text-right text-monochrome-600">
                    {formatRupiah(paymentData.nominal, "Rp. ")}
                  </p>
                </div>
              </div>
            </div>
          </CardSection>
        </div>
      </>
    );
  };

  async function SubmitRefund() {
    setShowModalLoading(true);

    const payload = {
      ewalletSubmission,
      project,
      retailer,
      nominal,
      description,
      withPayment: true,
    };

    try {
      await requestAuthPost("transaction/refund", payload).then((res) => {
        if (res.error) {
          toastNotify(res.message[0], "error");
        } else {
          if (!_.isEmpty(res)) {
            const { data } = res.data;
            const {
              integrations: { va },
            } = data;
            const dataToSet = {
              nominal: va.amount,
              id: va.id,
              proposalId: id,
              virtualAccount: va.vaNumber,
              expDate: va.expireDate,
              bankName: va.bankName,
              bankLogo: BANK_LOGO[va.bankName] || BANK_LOGO.MANDIRI,
            };
            localStorage.setItem("refundData", JSON.stringify(dataToSet));
            setPaymentData(dataToSet);
            setStep(2);
          }
        }
      });
    } catch {
      toastNotify("Gagal mengirim pengajuan refund", "error");
    } finally {
      setShowModalLoading(false);
    }
  }

  const CheckStatus = async (id, fromLocalStorage = false, goBack = false) => {
    setShowModalLoading(true);
    try {
      const res = await requestAuthGet(
        `transaction/check-status-va?idTrx=${id}`,
        {},
      );
      if (res.error) {
        toastNotify(res.message[0], "error");
      } else {
        const { data } = res.data;
        if (data.vaStatus === "COMPLETE") {
          setStep(3);
          setMessage({
            message: `Kami telah menerima dana refund dari Anda.`,
            type: "success",
            paymentMethod: `VA ${data.bankName}`,
            isShow: true,
          });
          localStorage.removeItem("refundData");
        } else {
          if (fromLocalStorage) {
            localStorage.removeItem("refundData");
            if (goBack) {
              navigate(-1, { replace: true });
            }
          }
          toastNotify(`Status refund anda ${data.vaStatus}`, "error");
        }
      }
    } catch (error) {
      console.log(error);
      toastNotify("Gagal memeriksa status refund", "error");
    } finally {
      setShowModalLoading(false);
    }
  };

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      {step === 3 && message.isShow && BannerMessage()}
      {step < 3 && (
        <div>
          <img src={bg} alt="" className="absolute top-0 -z-50 -mt-5 w-full" />
          <div className="mx-auto max-w-5xl space-y-5 px-5 pb-20 pt-5">
            {step < 4 && (
              <div
                className={`flex items-center ${step > 1 ? "justify-center" : "justify-between"}`}
              >
                {step < 2 && (
                  <button
                    onClick={() => {
                      if (step === 1) {
                        navigate(-1, { replace: true });
                      } else if (step === 3) {
                        setStep(2);
                        // setImageReceipt(null);
                      } else {
                        setStep(step - 1);
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                )}
                <div className="flex items-center justify-center gap-2">
                  <div
                    className={`px-1.5 ${
                      step >= 1
                        ? "gradient-bg text-white"
                        : "bg-gray-200 text-gray-500"
                    } flex h-7 w-7 items-center justify-center rounded-full text-sm font-medium`}
                    onClick={() => setStep(1)}
                  >
                    {step > 1 ? (
                      <svg
                        className="mx-auto h-6 w-6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={3}
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    ) : (
                      "1"
                    )}
                  </div>

                  {step === 1 ? (
                    <>
                      <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                        Detail Pengajuan Refund
                      </p>
                      <p className="text-lg text-monochrome-400">&#9656;</p>
                    </>
                  ) : (
                    <p className="text-lg text-monochrome-400">&#9656;</p>
                  )}
                  <div
                    className={`px-1.5 ${
                      step >= 2
                        ? "gradient-bg text-white"
                        : "bg-gray-200 text-gray-500"
                    } flex h-7 w-7 items-center justify-center rounded-full text-sm font-medium`}
                  >
                    2
                  </div>
                  {step === 2 ? (
                    <>
                      <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                        Proses Transfer Refund
                      </p>
                    </>
                  ) : (
                    <p className="text-lg text-monochrome-400"></p>
                  )}
                </div>
              </div>
            )}
            {step === 1 ? (
              <CardSection title="Pengajuan Refund">
                <div className="">
                  <div className="space-y-2">
                    <div className="flex justify-between text-xs">
                      <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                        ID Proposal
                      </div>
                      <p className="col-span-3 text-right text-monochrome-600">
                        {id ?? "-"}
                      </p>
                    </div>
                    <hr />

                    <div className="flex justify-between text-xs">
                      <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                        Deskripsi Proposal
                      </div>
                      <p className="col-span-3 text-right text-monochrome-600">
                        {description ?? "-"}
                      </p>
                    </div>

                    <div className="flex justify-between text-xs">
                      <div className="col-span-2 mb-1 font-medium text-monochrome-400">
                        VA Bank
                      </div>
                      <p className="col-span-3 text-right text-monochrome-600">
                        {bank ?? ""}
                      </p>
                    </div>
                    <hr />

                    <div className="flex justify-between text-xs">
                      <div className="col-span-2 mb-1 font-semibold text-monochrome-400">
                        Nominal Pengembalian
                      </div>
                      <p className="col-span-3 text-right font-semibold text-monochrome-600">
                        {formatRupiah(nominal, "Rp. ")}
                      </p>
                    </div>
                  </div>
                </div>
              </CardSection>
            ) : (
              <div className="mx-auto mt-5 flex flex-col gap-12 px-4">
                <p className="text-2xs text-monochrome-300">
                  ID Refund: {paymentData.id ?? "-"}
                </p>
                <div className="space-y-2">
                  <p className="text-xs font-semibold">Nomor Virtual Account</p>
                  <div className="flex h-12 items-center justify-between rounded-xl border border-purple-700 bg-white p-4 shadow-lg">
                    <img
                      src={paymentData.bankLogo}
                      alt="Mandiri"
                      className="h-full"
                    />
                    <p className="flex-1 text-center text-xs font-bold">
                      {formatAccountNumber(paymentData.virtualAccount)}
                    </p>
                    <p
                      className="flex min-w-[40px] cursor-pointer items-center justify-center text-2xs text-green-600"
                      onClick={() =>
                        copyVirtualAccount(paymentData.virtualAccount)
                      }
                    >
                      {copiedVirtualAccount ? (
                        <svg
                          className="mx-auto h-5 w-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        "Salin"
                      )}
                    </p>
                  </div>
                </div>
                <div className="space-y-2">
                  <p className="text-xs font-semibold">
                    Jumlah yang harus ditransfer
                  </p>
                  <div className="flex h-12 items-center justify-between rounded-xl border border-purple-700 bg-white p-4 shadow-lg">
                    <p className="text-xs font-bold">
                      {formatRupiah(paymentData.nominal, "Rp. ")}
                    </p>
                    <p
                      className="flex min-w-[40px] cursor-pointer items-center justify-center text-2xs text-green-600"
                      onClick={() => copyAmount(paymentData.nominal)}
                    >
                      {copiedAmount ? (
                        <svg
                          className="mx-auto h-5 w-5"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      ) : (
                        "Salin"
                      )}
                    </p>
                  </div>
                </div>
                <div className="space-y-4">
                  {paymentData.expDate && (
                    <div className="flex items-center justify-center">
                      <CountdownRenderer
                        paymentData={paymentData}
                        CheckStatus={CheckStatus}
                      />
                    </div>
                  )}
                  <div className="mx-auto flex max-w-lg items-center gap-3 rounded-xl bg-[#ecedfe] px-4 py-2">
                    <svg
                      viewBox="0 0 24 24"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12"
                      // xmlns:xlink="http://www.w3.org/1999/xlink"
                      fill="#000000"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <title>information_fill</title>{" "}
                        <g
                          id="页面-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          {" "}
                          <g
                            id="System"
                            transform="translate(-672.000000, -48.000000)"
                            fill-rule="nonzero"
                          >
                            {" "}
                            <g
                              id="information_fill"
                              transform="translate(672.000000, 48.000000)"
                            >
                              {" "}
                              <path
                                d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                                id="MingCute"
                                fill-rule="nonzero"
                              >
                                {" "}
                              </path>{" "}
                              <path
                                d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M11.99,10 L11,10 C10.4477,10 10,10.4477 10,11 C10,11.51285 10.386027,11.9355092 10.8833761,11.9932725 L11,12 L11,16.99 C11,17.5106133 11.3938293,17.9392373 11.8999333,17.9940734 L12.01,18 L12.5,18 C13.0523,18 13.5,17.5523 13.5,17 C13.5,16.6710222 13.3411062,16.3791012 13.0958694,16.1968582 L13,16.1338 L13,11.01 C13,10.4893867 12.6060836,10.0607627 12.1000493,10.0059266 L11.99,10 Z M12,7 C11.4477,7 11,7.44772 11,8 C11,8.55228 11.4477,9 12,9 C12.5523,9 13,8.55228 13,8 C13,7.44772 12.5523,7 12,7 Z"
                                id="形状"
                                fill="#4343ef"
                              >
                                {" "}
                              </path>{" "}
                            </g>{" "}
                          </g>{" "}
                        </g>{" "}
                      </g>
                    </svg>
                    <p className="text-2xs text-monochrome-400">
                      Pembayaran akan otomatis dibatalkan jika waktu pembayaran
                      kamu telah habis
                    </p>
                  </div>
                </div>
                <PaymentInstructions bankName={paymentData.bankName} />
              </div>
            )}
          </div>
        </div>
      )}

      <div className="fixed bottom-0 w-full bg-white">
        <div className="flex max-w-full flex-col space-y-2 px-4 py-2 md:mx-auto md:max-w-5xl md:px-8">
          <Button
            className="w-full md:w-auto"
            variant={step < 3 ? "gradient" : "default"}
            label={
              step === 1
                ? "Konfirmasi Refund"
                : step === 3
                  ? "Kembali"
                  : "Cek Status Refund"
            }
            onClick={() => {
              if (step === 1) {
                SubmitRefund();
              } else if (step === 2) {
                CheckStatus(paymentData.id);
              } else if (step === 3) {
                navigate("/direct-cash-management", { replace: true });
              } else {
                setStep(step + 1);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default RefundConfirmation;
